import type { WasmPathCertification } from "@csk/demo-ui/domain";

export function wasmBridgeProofSummary(
  certification: WasmPathCertification,
): string {
  const proof = certification.bridgeProof;
  const witness =
    proof.witnessId === null
      ? "no witness receipt"
      : `witness #${proof.witnessId.toString()}`;
  const phases =
    proof.phases === null ? "no SNF receipt" : proof.phases.join("→");
  const resources =
    proof.consumedResources.length === 0
      ? "no consumed resources"
      : proof.consumedResources.join(", ");
  const replay = proof.replayRejected ? "replay refused" : "replay still open";
  const witnessReplay =
    proof.witnessReplayRejected === null
      ? `witness uses left ${proof.remainingWitnessUses.toString()}`
      : proof.witnessReplayRejected
        ? "witness replay refused"
        : "witness replay still open";
  const square = `${certification.squareDecision.squareId}:${certification.squareDecision.status}`;

  return [
    `bridge #${proof.bridgeId.toString()}`,
    proof.admission.status,
    square,
    witness,
    phases,
    resources,
    replay,
    witnessReplay,
  ].join(" · ");
}
